// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"52":"b29ae11f","82":"1c94d57b","84":"71d65c00","87":"ec12a73b","227":"ef4c4744","634":"90d54ec3","673":"e2f90698","725":"60742dcd","748":"d322598a","818":"bde56618"}[chunkId] + ".js";
};